import type { ProductMenuTile } from '@/platform/lib/product-nav';
import { shortcutIcon } from '@/products/intranet/features/intranet/shortcut-icons';
import { useIntranetQuickAccess } from '@/products/intranet/features/intranet/use-intranet-directory';

/** Schnellzugriff tiles for the selected Intranet module in the mobile Menü. */
export function useIntranetMenuTiles(): ProductMenuTile[] {
  const quickAccess = useIntranetQuickAccess();
  return (quickAccess.data?.items ?? []).map((item) => ({
    id: `shortcut-${item.id}`,
    label: item.label,
    to: item.url,
    icon: shortcutIcon(item.iconName),
  }));
}
